import { Link } from "react-router-dom";

function PageNotFound() {
  return (
    <div className="comingsoon-page">
      <div className="comingsoon-content">
        <h1 className="page-not-found">404</h1>
        <h1>
          <i className="ri-error-warning-line"></i> Page Not Found
        </h1>
        <Link to="/" className="btn btn-primary btn-blue">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default PageNotFound;
